import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';

export const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    // borderRadius: 4,
    position: 'relative',
    background: "#899DB9 0% 0% no-repeat padding-box",
    // background: "#FFFFFF 0% 0% no-repeat padding-box",
    // border: "1px solid #C9C9C9",
    // borderRadius: "5px",
    border: "1px solid #EBF3F4",
    opacity: "1",
    padding: '10px 26px 4px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    font: "normal normal normal 18px/21px Arial",
    // color: "#757575",
    color: "#FFFFFF",

    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      'Helvetica',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      // borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  '& .MuiSvgIcon-root': {
    color: "#000 !important"
  }
}));